import m from "mithril";
import Loading from "../../shared/loading";
import Page_Unit_Scorm from "./scorm/scorm";
import Page_Unit_Event from "./event/event";
import Page_Unit_Form from "./form/form";
import Page_Unit_Certificate from "./certificate/certificate";
import Page_Unit_Document from "./document/document";
import Page_Unit_Action from "./action/action";
import Page_Unit_Approval from "./approval/approval";
import Page_Unit_Download from "./download/download";
import Page_Unit_Upload from "./upload/upload";
import Page_Unit_Assessment from "./assessment/assessment";

import Requester from "../../shared/request";
import Gateway from "../../shared/app_settings";
import Toasts from "../../shared/toasts";
import {UnitTypes} from "../values";
import i18n from "../../shared/i18n/i18n";
import RouterService from "../../shared/services/router.service";

let loading = false;
let unit = null;
let unitClass = null;

function loadUnit(id) {
    loading = true;
    return Requester.get(Gateway.admin + "units/" + id)
        .then(result => {
            unit = result;
            unitClass = result.class;
        })
        .catch(error => {
            const msg = error?.response?.properties?.errorCode || "unknown_error";
            Toasts.add("error", i18n.t("error"), i18n.t(msg));
        })
        .finally(() => {
            loading = false;
            m.redraw();
        });
}

const componentMap = [
    { type: UnitTypes.scorm, component: Page_Unit_Scorm },
    { type: UnitTypes.event, component: Page_Unit_Event },
    { type: UnitTypes.form, component: Page_Unit_Form },
    { type: UnitTypes.assessment, component: Page_Unit_Assessment },
    { type: UnitTypes.cert, component: Page_Unit_Certificate },
    { type: UnitTypes.doc, component: Page_Unit_Document },
    { type: UnitTypes.action, component: Page_Unit_Action },
    { type: UnitTypes.approval, component: Page_Unit_Approval },
    { type: UnitTypes.download, component: Page_Unit_Download },
    { type: UnitTypes.upload, component: Page_Unit_Upload }
];

function resolveComponent() {
    if (!unit || !unitClass) return null;
    const match = componentMap.find(entry => unitClass.includes(entry.type));
    return match ? m(match.component, { unit }) : null;
}

const Page_Unit = {
    oninit: ({ attrs }) => {
        loadUnit(attrs.id);
    },
    view: () => {
        if (loading) {
            return m(Loading);
        }

        if (!unit) {
            return m(".text-gray.padding", i18n.t("invalid_unit"));
        }

        const component = resolveComponent();

        return component || [
            m("div", i18n.t("invalid_unit_type")),
            m(m.route.Link, { href: RouterService.getUnitsUrl() }, i18n.t("back_to_all_units"))
        ];
    }
};

export default Page_Unit;
